import '../tailwind.css';
import '../scss/theme.scss';


import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";

import '../js/navigation.js';
import '../js/components/offcanvas-cart.js';

import initQueryCarousels from '../js/components/query-carousel.js';
import { initCounterElements } from '../js/components/counter-elements.js';

document.addEventListener('DOMContentLoaded', () => {
	initQueryCarousels();
	initCounterElements();
	hst_back_to_top();
	hst_job_career();
});


gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,SplitText);


/**
 * Smooth anchor scrolling for any in-page #link.
 */
function smoothScroll() {
	const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"])');

	anchors.forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			const href = this.getAttribute('href');
			// Ignore non-selectors (e.g. "#" alone, already filtered, but double-check)
			if (!href || href === '#' || href.length < 2) return;

			const targetElement = document.querySelector(href);
			if (!targetElement) return;

			e.preventDefault();
			targetElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		});
	});
}

/**
 * Reveal-on-scroll animations (GSAP + ScrollTrigger).
 */
function gsapAnimations() {
	const fadeConfigs = [
		{ selector: '.gs--fadeInFromUp',            to: { opacity: 1, y: 0 } },
		{ selector: '.gs--fadeInFromDown',          to: { opacity: 1, y: 0 } },
		{ selector: '.gs--fadeInFromRight',         to: { opacity: 1, x: 0 } },
		{ selector: '.gs--fadeInFromLeft',          to: { opacity: 1, x: 0 } },
		{ selector: '.gs--fadeInDiagonalFromLeft',  to: { opacity: 1, x: 0, y: 0 } },
		{ selector: '.gs--fadeInDiagonalFromRight', to: { opacity: 1, x: 0, y: 0 } },
	];

	fadeConfigs.forEach(({ selector, to }) => {
		if (!document.querySelector(selector)) return;
		ScrollTrigger.batch(selector, {
			start: 'top 90%',
			onEnter: (elements) => {
				gsap.to(elements, { ...to, stagger: 0.25, duration: 0.75 });
			},
		});
	});

	if (document.querySelector('.gs--maskUp')) {
		ScrollTrigger.batch('.gs--maskUp', {
			start: 'top 90%',
			onEnter: (elements) => {
				gsap.to(elements, {
					clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
					y: 0,
					duration: 1,
				});
			},
		});
	}

	if (document.querySelector('.gs--fadeInToOpacity')) {
		ScrollTrigger.batch('.gs--fadeInToOpacity', {
			start: 'top 70%',
			onEnter: (elements) => {
				gsap.to(elements, { opacity: 1, y: 0, duration: 0.5 });
			},
		});
	}

	if (document.querySelector('.gs--cardReveal')) {

		gsap.set('.gs--cardReveal', {
			autoAlpha: 0,
			y: 32,
		});
		ScrollTrigger.batch('.gs--cardReveal', {
			start: 'top 85%',
			once: true,
			batchMax: 6,
			onEnter: (batch) => {
				gsap.to(batch, {
					autoAlpha: 1,
					y: 0,
					duration: 0.7,
					ease: 'power3.out',
					stagger: 0.12,
					clearProps: 'transform,opacity,visibility',
				});
			},
		});
	}

}
gsapAnimations();

/**
 * Generic accordion: [data-accordion] wrapper + .hst-accordion-header / .hst-accordion-body.
 */
function accordion() {
	document.querySelectorAll('.hst-accordion-header').forEach((item) => {
		item.addEventListener('click', (e) => {
			const target = document.querySelector(item.getAttribute('data-target'));
			if (!target) return;

			if (target.style.maxHeight && target.style.maxHeight !== '0px') {
				target.style.maxHeight = '0px';
			} else {
				target.style.maxHeight = target.scrollHeight + 'px';
			}

			e.currentTarget.parentElement.classList.toggle('open');
		});
	});
}

/**
 * Tabs: [data-tab-target] triggers + .tab-content panels.
 */
function tabs() {
	const tabButtons  = document.querySelectorAll('[data-tab-target]');
	const tabContents = document.querySelectorAll('.tab-content');

	if (!tabButtons.length) return;

	const switchTab = (targetId) => {
		tabButtons.forEach((t) => t.classList.remove('active'));
		tabContents.forEach((c) => c.classList.remove('active'));

		const targetTab     = document.querySelector(`[data-tab-target="${targetId}"]`);
		const targetContent = document.getElementById(targetId);

		if (targetTab && targetContent) {
			targetTab.classList.add('active');
			targetContent.classList.add('active');
		}
	};

	tabButtons.forEach((tab) => {
		tab.addEventListener('click', (e) => {
			switchTab(e.currentTarget.getAttribute('data-tab-target'));
		});
	});

	switchTab(tabButtons[0].getAttribute('data-tab-target'));
}



function hst_back_to_top(){


	const button = document.querySelector('#back-to-top');
	const footer = document.querySelector('footer');

	if (!button || !footer || typeof gsap === 'undefined') {
		return;
	}

	let isVisible = false;

	gsap.set(button, {
	autoAlpha: 0,
		y: 16,
		scale: 0.92,
		display: 'none',
	});

	const showButton = () => {
		if (isVisible) {
			return;
		}

		isVisible = true;

		gsap.killTweensOf(button);

		gsap.set(button, {
			display: 'flex',
		});

		gsap.to(button, {
			autoAlpha: 1,
			y: 0,
			scale: 1,
			duration: 0.35,
			ease: 'power3.out',
		});
	};

	const hideButton = () => {
		if (!isVisible) {
			return;
		}

		isVisible = false;

		gsap.killTweensOf(button);

		gsap.to(button, {
			autoAlpha: 0,
			y: 16,
			scale: 0.92,
			duration: 0.25,
			ease: 'power2.in',
			onComplete: () => {
				if (!isVisible) {
					gsap.set(button, {
						display: 'none',
					});
				}
			},
		});
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					showButton();
				} else {
					hideButton();
				}
			});
		},
		{
			root: null,
			threshold: 0.1,
		}
	);

	observer.observe(footer);

	button.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	});

}




function hst_job_career() {
  const jobArticles = document.querySelectorAll('.single-job-position');
  const form = document.querySelector('.wpcf7 form');
  const select = form ? form.querySelector('.options-hst-careers') : null;

  if (!jobArticles.length || !form || !select) {
    return;
  }

  const jobTitles = Array.from(jobArticles)
    .map(function (article) {
      const titleEl = article.querySelector('.hst-job-title');
      return titleEl ? titleEl.textContent.trim() : '';
    })
    .filter(Boolean);

  const existingValues = Array.from(select.options).map(function (option) {
    return option.value.trim();
  });

  jobTitles.forEach(function (title) {
    if (existingValues.includes(title)) {
      return;
    }

    const option = document.createElement('option');
    option.value = title;
    option.textContent = title;

    select.appendChild(option);
    existingValues.push(title);
  });

  const applyButtons = document.querySelectorAll('.single-job-apply');

  applyButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      const article = button.closest('.single-job-position');

      if (!article) {
        return;
      }

      const titleEl = article.querySelector('.hst-job-title');
      const jobTitle = titleEl ? titleEl.textContent.trim() : '';

      if (!jobTitle) {
        return;
      }

      select.value = jobTitle;

      select.dispatchEvent(new Event('change', {
        bubbles: true,
      }));

      form.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  });
}